export default class MovieSet {

    constructor($container, movieId, controller) {

        let _this = this;
        this.$container = $container;
        this.controller = controller;
        this.movieId = movieId;
        this.$trigger = this.$container.find('.prg-movie-trigger').eq(0);
        this.$trigger.on('click', function () {
            _this.controller.playMovie(_this.movieId);
        });

    }

}



// WEBPACK FOOTER //
// ./src/scripts/MovieSet.js